import { render, staticRenderFns } from "./menu-switcher.vue?vue&type=template&id=9e51b568&scoped=true"
import script from "./menu-switcher.vue?vue&type=script&lang=ts"
export * from "./menu-switcher.vue?vue&type=script&lang=ts"
import style0 from "./menu-switcher.vue?vue&type=style&index=0&id=9e51b568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e51b568",
  null
  
)

export default component.exports